import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cssStyles from './ContactItem.css';

class GroupContact extends Component {
  static propTypes = {
    contact: PropTypes.object,
  };

  static defaultProps = {
    contact: {},
  };

  getContactMembers() {
    const {
      contact: { memberCount },
    } = this.props;
    if (memberCount === undefined) {
      return null;
    }
    return (
      <div className={cssStyles.contactDesc}>
        <FormattedMessage
          id='channel_member_count'
          values={{ count: memberCount }}
        />
      </div>
    );
  }

  getDescription() {
    const {
      contact: { description, groupType, isJoined },
    } = this.props;
    if (!description || groupType !== 'open' || isJoined) {
      return null;
    }
    return (
      <div className={cssStyles.groupDescription} title={description}>
        {description}
      </div>
    );
  }

  getJoinButton() {
    const {
      contact: { isGroup, groupType, isJoined },
    } = this.props;
    if (!isGroup || groupType !== 'open' || isJoined) {
      return null;
    }

    return <div className={cssStyles.joinButton} />;
  }

  render() {
    const {
      contact: { name, nameAutoComplete, imageUrl },
    } = this.props;
    return (
      <div>
        <div className={cssStyles.flex}>
          <div
            className={`${cssStyles.relative} ${cssStyles.thumbnaildimensions}`}
          >
            <img className={cssStyles.thumbnail} src={imageUrl} alt={name} />
          </div>
          <div className={cssStyles.contactDetails}>
            <div className={cssStyles.contactName}>
              {name}
              <span className={cssStyles.contactNameAutoComplete}>
                {nameAutoComplete || ''}
              </span>
            </div>
            {this.getContactMembers()}
          </div>
          {this.getJoinButton()}
        </div>
        {this.getDescription()}
      </div>
    );
  }
}

export default GroupContact;



// WEBPACK FOOTER //
// ./src/components/Search/ContactSearch/ContactList/ContactBucket/ContactItem/GroupContact.js